document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.category-link').forEach((link) => {
    link.addEventListener('click', function (e) {
      e.preventDefault(); // Prevent the default anchor behavior

      const templateContent = this.parentNode.querySelector('.ob-size-guide-template').innerHTML;
      const modal = document.getElementById('ob-template-sizeGuideModal');
      modal.querySelector('.ob-template-modal-body').innerHTML = templateContent; // Populate modal with the content

      modal.style.display = 'block'; // Show the modal

      // Focus on the modal
      modal.focus();

      // Trap focus inside modal
      trapFocus(modal);

      // Initialize the size guide script for the new content
      initializeSizeGuideScript();
    });
  });

  const closeButton = document.querySelector('.ob-template-close-button');
  closeButton.addEventListener('click', function () {
    const modal = document.getElementById('ob-template-sizeGuideModal');
    modal.style.display = 'none'; // Hide the modal
    modal.querySelector('.ob-template-modal-body').innerHTML = ''; // Clear the modal content
  });

  // Add a 'keydown' event listener to the close button
  closeButton.addEventListener('keydown', function (event) {
    // Check if the key pressed is "Enter"
    if (event.key === 'Enter' || event.keyCode === 13) {
      const modal = document.getElementById('ob-template-sizeGuideModal');
      modal.style.display = 'none'; // Hide the modal
      modal.querySelector('.ob-template-modal-body').innerHTML = ''; // Clear the modal content
    }
  });

  window.addEventListener('click', function (event) {
    const modal = document.getElementById('ob-template-sizeGuideModal');
    if (event.target === modal) {
      modal.style.display = 'none';
      modal.querySelector('.ob-template-modal-body').innerHTML = ''; // Clear the modal content
    }
  });
});

function trapFocus(element) {
  const focusableElements = element.querySelectorAll(
    'a, button, input, select, textarea, span ,[tabindex]:not([tabindex="-1"])'
  );

  // If no focusable elements are found, do nothing
  if (focusableElements.length === 0) return;

  const firstElement = focusableElements[0];
  const lastElement = focusableElements[focusableElements.length - 1];

  element.addEventListener('keydown', function (event) {
    if (event.key === 'Tab') {
      if (event.shiftKey) {
        // If Shift + Tab is pressed, focus the last element when at the first one
        if (document.activeElement === firstElement) {
          event.preventDefault();
          lastElement.focus();
        }
      } else {
        // If Tab is pressed, focus the first element when at the last one
        if (document.activeElement === lastElement) {
          event.preventDefault();
          firstElement.focus();
        }
      }
    }
  });
}

function initializeSizeGuideScript() {
  const unitSelector = document.getElementById('unitSelector');
  if (unitSelector) {
    unitSelector.addEventListener('change', function () {
      var unit = this.value;
      document.getElementById('tableInches').classList.toggle('hidden', unit !== 'inches');
      document.getElementById('tableCm').classList.toggle('hidden', unit !== 'cm');
    });

    // Trigger the change event to set the default view
    var event = new Event('change');
    unitSelector.dispatchEvent(event);
  }
}
